import AxiosService from '../../../gateway/rest/AxiosService'

class MssqlIndexingRestService {
  static async enableIndex(policyId: number) {
    AxiosService.post('/adaptermssql/index/enableIndex', null, {
      params: {
        policyId,
      },
    })
  }

  static async disableIndex(policyId: number) {
    AxiosService.post('/adaptermssql/index/disableIndex', null, {
      params: {
        policyId,
      },
    })
  }

  static async rebuildIndex(policyId: number) {
    AxiosService.post('/adaptermssql/index/rebuildIndex', null, {
      params: {
        policyId,
      },
    })
  }
}

export default MssqlIndexingRestService
